export const OPEN_TAB = "OPEN_TAB";

const initialState = {
  tab: "1",
  id: "",
};

export const TabReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_TAB:
      return {
        ...state,
        tab: action.payload.tab,
        id: action.payload.id || "",
      };
    default:
      return state;
  }
};
